import Lottie from "lottie-react";
import Successful from "@/assets/lotties/successful.json";
import {ModalType} from "@/components/modal/NewModuleModal.tsx";
import {useSelector} from "react-redux";
import {RootState} from "@/store";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCopy} from "@fortawesome/free-solid-svg-icons";
import copy from "copy-to-clipboard";


function SuccessDeployModal({show, onClose}: ModalType) {
    const deployState = useSelector((state: RootState) => state.deploy);
    const handleCopy = () => {
        const textToCopy = deployState.swaggerUrl
        copy(textToCopy)
    }
    return (
        <>
            {show &&
                (
                    <div className="modal-overlay">
                        <div className="modal">
                            <div className={"success-modal"}>
                                <div className={"success-modal-img"}>
                                    <Lottie animationData={Successful} style={{width: "100px", height: "100px"}}
                                            loop={true}/>
                                </div>
                                <div className={"success-modal-text"}>
                                    <p className={"modal-title"}>{"Deployed Successfully"}</p>
                                    <div style={{display: "flex", gap: "1rem"}}>
                                        <div
                                            className={"modal-body"}
                                            style={{
                                                width: '300px',
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis"
                                            }}>Swagger
                                            URL: {`${deployState.swaggerUrl}`}
                                        </div>
                                        {<button onClick={handleCopy} id="copyBtn">
                                            <FontAwesomeIcon icon={faCopy}/> Copy
                                        </button>
                                        }
                                    </div>
                                    {/*<p className={"modal-body"}>{deployState.swaggerUrl}</p>*/}
                                    <div className={"success-modal-btn"}>
                                        <button onClick={onClose} className={"continue-btn"}>Proceed</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
        </>

    );
}

export default SuccessDeployModal;
